// Code review - Completed
// Documentation - Completed
import React, { useEffect, useRef, useState } from "react";
import { mainTable } from "../css/Common";
import { Link, useNavigate } from "react-router-dom";
import MainPopup from "../popup-containers/MainPopup";
import DropDown from "../ReusableComponents/DropDown";
import { MdAdd } from "react-icons/md";
import InputText from "../ReusableComponents/InputText";
import youtube from "../image/youtube.jpg";
import pdf from "../image/pdf.png";
import download from "../image/download.png";
import RadioGroup from "../ReusableComponents/RadioButton";
import TextArea from "../ReusableComponents/TextArea";
import { BindAPI } from "../services/APIConnection";
import toast from "react-hot-toast";
import { useAppData } from "./AppDataContext";
const TableGrid = ({
  tableHeight,
  headerData,
  tableData,
  onEditGrid,
  onViewGrid,
  onDeleteGrid,
  onBlockGrid,
  onAddressGrid,
  currentPage,
  itemsPerPage,
  viewBag,
  editBag,
  deleteBag,
  blockBag,
  serviceBag,
  deactivateBag,
  onSchoolView,
  tableView,
  xScroll,
  tableScroll,
  onAdd,
  onDisabled,
  onConfirmBooking,
  onLostEnquiry,
  onHoldEnquiry,
  onCancelEnquiry,
  onMap,
  onLaundryIssueView,
  onViewFile,
  onMapView,
  onConsumptionView,
}) => {
  let currentData = [];
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [action, setAction] = useState([]);
  const dropdownRef = useRef(null);
  const [startIndex, setStartIndex] = useState(0);
  if (currentPage) {
    if (Array.isArray(tableData)) {
      if (itemsPerPage === -1) {
        currentData = tableData; // No slicing, show all data
      } else {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        currentData = tableData.slice(startIndex, endIndex); // Pagination logic
      }
    }
  } else {
    currentData = [tableData];
  }
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        showPopUp(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);
  const navigate = useNavigate();
  const [viewsAll, setViewsAll] = useState(false);

  const [viewImage, setViewImage] = useState({ popup: false, url: "" });
  const [currentRowIndex, setCurrentRowIndex] = useState(null);
const { itemsPerPages, bindDDValues, loading } = useAppData();
const [NODtoEditPastEntries, setNODtoEditPastEntries] =
    useState(itemsPerPages);


  const showPopUp = (views, rowIndex) => {
    setViewsAll(views);
    setCurrentRowIndex(views ? rowIndex : null);
  };


  return (
    <div className={mainTable.tableShadowWidth}>
      <div
        className={`${tableScroll ? tableScroll : mainTable.table}`}
        role="table"
      >
        <div className={`${xScroll ? xScroll : mainTable.xScroll}`}>
          <div className={mainTable.tableHeader} role="rowgroup">
            {headerData.map((item, itemIndex) => (
              <div className={item.width} role="columnheader">
                <label class="text-sm  font-medium">{item.title}</label>
              </div>
            ))}
          </div>

          <div
            className={`overflow-y-auto ${
              tableHeight ? tableHeight : "h-80 overflow-y-auto"
            } `}
          >
            {currentData.length > 0 ? (
              currentData.map((data, rowIndex) => (
                <div class={mainTable.tableRow}>
                  {headerData.map((keyData) => (
                    <div scope="cell" role="cell" className={keyData.width}>
                      {keyData.key === "address" ||
                      keyData.key === "details" ? (
                        <button
                          onClick={() => onAddressGrid(data.oldIndex, 1)}
                          class="relative px-5 py-2 overflow-hidden font-medium text-gray-600 bg-gray-100 border border-gray-100 rounded-lg shadow-inner group"
                        >
                          <span class="absolute top-0 left-0 w-0 h-0 transition-all duration-200 border-t-2 border-gray-600 group-hover:w-full ease"></span>
                          <span class="absolute bottom-0 right-0 w-0 h-0 transition-all duration-200 border-b-2 border-gray-600 group-hover:w-full ease"></span>
                          <span class="absolute top-0 left-0 w-full h-0 transition-all duration-300 delay-200 bg-gray-600 group-hover:h-full ease"></span>
                          <span class="absolute bottom-0 left-0 w-full h-0 transition-all duration-300 delay-200 bg-gray-600 group-hover:h-full ease"></span>
                          <span class="absolute inset-0 w-full h-full duration-300 delay-300 bg-gray-900 opacity-0 group-hover:opacity-100"></span>
                          <span class="relative transition-colors duration-300 delay-200 group-hover:text-white ease">
                            View
                          </span>
                        </button>
                      ) : keyData.key === "action" ? (
                        <div>
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => showPopUp(!viewsAll, rowIndex)}
                          >
                            <svg
                              class="w-6 h-6"
                              aria-hidden="true"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                            </svg>
                          </button>
                          {viewsAll && currentRowIndex == rowIndex && (
                            <div
                              ref={dropdownRef}
                              id="dropdownDots"
                              class="z-10 bg-white absolute right-14 divide-y divide-gray-100 rounded-lg shadow w-44"
                            >
                              <ul
                                class=""
                                aria-labelledby="dropdownMenuIconButton"
                              >
                                {viewBag == 1 && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onViewGrid(data.oldIndex, 1);
                                        showPopUp(false);
                                      }}
                                       title="Click to view"
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      View
                                    </a>
                                  </li>
                                )}
                                {editBag == 1 && !data.InActivatedBy && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onEditGrid(data.oldIndex, 2);
                                        showPopUp(false);
                                      }}
                                          title="Click to Edit"
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      Edit
                                    </a>
                                  </li>
                                )}
                                {deleteBag == 1 && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onDeleteGrid(data.oldIndex, 3);
                                        showPopUp(false);
                                      }}
                                          title="Click to Delete"
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      Delete
                                    </a>
                                  </li>
                                )}

                                {blockBag == 1 && (
                                  <li>
                                    {data.InActivatedBy ? (
                                      <a
                                        onClick={() => {
                                          onBlockGrid(data.oldIndex, 5);
                                          showPopUp(false);
                                        }}
                                            title="Click to  Make Active"
                                        class="block px-4 py-2 hover:bg-gray-100"
                                      >
                                        Make Active
                                      </a>
                                    ) : (
                                      <a
                                        onClick={() => {
                                          onBlockGrid(
                                            data.oldIndex,

                                            4
                                          );
                                          showPopUp(false);
                                        }}
                                        title="Click to  Make InActive"
                                        class="block px-4 py-2 hover:bg-gray-100"
                                      >
                                        Make InActive
                                      </a>
                                    )}
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      ) : keyData.key === "action10" ? (
                        <div>
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => showPopUp(!viewsAll, rowIndex)}
                          >
                            <svg
                              class="w-6 h-6"
                              aria-hidden="true"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                            </svg>
                          </button>
                          {viewsAll && currentRowIndex == rowIndex && (
                            <div
                              ref={dropdownRef}
                              id="dropdownDots"
                              class="z-10 bg-white absolute right-14 divide-y divide-gray-100 rounded-lg shadow w-44"
                            >
                              <ul
                                class=""
                                aria-labelledby="dropdownMenuIconButton"
                              >
                                {viewBag == 1 && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onViewGrid(data.oldIndex, 1);
                                        showPopUp(false);
                                      }}
                                       title="click to view"
                                      class="block px-4 py-2 hover:bg-gray-100"
                                   >
                                      View
                                    </a>
                                  </li>
                                )}
                                {editBag == 1 && !data.InActivatedBy && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onEditGrid(
                                          data.oldIndex,
                                          2
                                        );
                                        showPopUp(false);
                                      }}
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      Edit
                                    </a>
                                  </li>
                                )}
                                {deleteBag == 1 && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onDeleteGrid(
                                          data.oldIndex,
                                          3
                                        );
                                        showPopUp(false);
                                      }}
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      Delete
                                    </a>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      ) : keyData.key === "actionWithOutInactiveAndDelete" ? (
                        <div>
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => showPopUp(!viewsAll, rowIndex)}
                          >
                            <svg
                              class="w-6 h-6"
                              aria-hidden="true"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                            </svg>
                          </button>
                          {viewsAll && currentRowIndex == rowIndex && (
                            <div
                              ref={dropdownRef}
                              id="dropdownDots"
                              class="z-10 bg-white absolute right-14 divide-y divide-gray-100 rounded-lg shadow w-44"
                            >
                              <ul
                                class=""
                                aria-labelledby="dropdownMenuIconButton"
                              >
                                {viewBag == 1 && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onViewGrid(data.oldIndex, 1);
                                        showPopUp(false);
                                      }}
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      View
                                    </a>
                                  </li>
                                )}
                                {editBag == 1 && !data.InActivatedBy && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onEditGrid(
                                          data.oldIndex,

                                          2
                                        );
                                        showPopUp(false);
                                      }}
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      Edit
                                    </a>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      ) : //////////////////////trial lost added
                      keyData.key === "actionlost" ? (
                        <div>
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => {
                              onLostEnquiry(data.oldIndex, 2);
                              showPopUp(false);
                            }}
                          >
                            {/* <svg
                              xmlns="http://www.w3.org/2000/svg"
                              x="0px"
                              y="0px"
                              width="24"
                              height="24"
                              viewBox="0 0 48 48"
                            >
                              <path
                                fill="#f44336"
                                d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
                              ></path>
                              <path
                                fill="#fff"
                                d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z"
                              ></path>
                              <path
                                fill="#fff"
                                d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z"
                              ></path>
                            </svg> */}
                            <svg
  xmlns="http://www.w3.org/2000/svg"
  width="22"
  height="22"
  viewBox="0 0 24 24"
  fill="none"
  stroke="black"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
>
  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
  <circle cx="12" cy="12" r="3" />
</svg>
                          </button>
                        </div>
                      ) : ////trial lost ended
                      //////////////////////trial added
                      keyData.key === "action1" ? (
                        <div>
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => {
                              onConfirmBooking(data.oldIndex, 2);
                              showPopUp(false);
                            }}
                            title="Click to Confirm Booking"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="24"
                              height="24"
                            >
                              <mask id="lineMdCircleFilledToConfirmCircleFilledTransition0">
                                <g
                                  fill="none"
                                  stroke="#fff"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                >
                                  <path
                                    fill="#fff"
                                    d="M3 12c0 -4.97 4.03 -9 9 -9c4.97 0 9 4.03 9 9c0 4.97 -4.03 9 -9 9c-4.97 0 -9 -4.03 -9 -9Z"
                                  ></path>
                                  <path
                                    stroke="#000"
                                    strokeDasharray="14"
                                    strokeDashoffset="14"
                                    d="M8 12l3 3l5 -5"
                                  >
                                    <animate
                                      fill="freeze"
                                      attributeName="stroke-dashoffset"
                                      dur="0.2s"
                                      values="14;0"
                                    ></animate>
                                  </path>
                                </g>
                              </mask>
                              <rect
                                width="24"
                                height="24"
                                fill="currentColor"
                                mask="url(#lineMdCircleFilledToConfirmCircleFilledTransition0)"
                              ></rect>
                            </svg>
                          </button>

                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => {
                              onLostEnquiry(data.oldIndex, 2);
                              showPopUp(false);
                            }}
                             title="Click to Lost Enquiry"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              x="0px"
                              y="0px"
                              width="24"
                              height="24"
                              viewBox="0 0 48 48"
                            >
                              <path
                                fill="#f44336"
                                d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
                              ></path>
                              <path
                                fill="#fff"
                                d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z"
                              ></path>
                              <path
                                fill="#fff"
                                d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z"
                              ></path>
                            </svg>
                          </button>
                          {/* <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => {
                              onHoldEnquiry(data.oldIndex, 2);
                              showPopUp(false);
                            }}
                          >
                           <svg
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M12 4C9.243 4 7 6.243 7 9h2c0-1.654 1.346-3 3-3s3 1.346 3 3c0 1.069-.454 1.465-1.481 2.255-.382.294-.813.626-1.226 1.038C10.981 13.604 10.995 14.897 11 15v2h2v-2.009c0-.024.023-.601.707-1.284.32-.32.682-.598 1.031-.867C15.798 12.024 17 11.1 17 9c0-2.757-2.243-5-5-5zm-1 14h2v2h-2z" />
                            </svg>
                          </button> */}
                        </div>
                      ) : keyData.key === "UploadAction" ? (
                        <div className="relative inline-block">
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => showPopUp(!viewsAll, rowIndex)}
                          >
                            <svg
                              class="w-6 h-6"
                              aria-hidden="true"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                            </svg>
                          </button>
                          {viewsAll && currentRowIndex == rowIndex && (
                            <div
                              ref={dropdownRef}
                              id="dropdownDots"
                              class="z-10 bg-white absolute right-14 divide-y divide-gray-100 rounded-lg shadow w-44"
                            >
                              <ul
                                class=""
                                aria-labelledby="dropdownMenuIconButton"
                              >
                                {viewBag == 1 && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onViewGrid(data.oldIndex, 1);
                                        showPopUp(false);
                                      }}
                                      title="click to view"
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      View
                                    </a>
                                  </li>
                                )}
                                {editBag == 1 &&
                                  !data.InActivatedBy &&
                                  data.Type != "VCP" && (
                                    <li>
                                      <a
                                        onClick={() => {
                                          onEditGrid(data.oldIndex, 2);
                                          showPopUp(false);
                                        }}
                                        class="block px-4 py-2 hover:bg-gray-100"
                                      >
                                        Edit
                                      </a>
                                    </li>
                                  )}
                                {deleteBag == 1 && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onDeleteGrid(data.oldIndex, 3);
                                        showPopUp(false);
                                      }}
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      Delete
                                    </a>
                                  </li>
                                )}
                                {blockBag == 1 && (
                                  <li>
                                    {data.InActivatedBy ? (
                                      <a
                                        onClick={() => {
                                          onBlockGrid(data.oldIndex, 5);
                                          showPopUp(false);
                                        }}
                                        class="block px-4 py-2 hover:bg-gray-100"
                                      >
                                        Make Active
                                      </a>
                                    ) : (
                                      <a
                                        onClick={() => {
                                          onBlockGrid(data.oldIndex, 4);
                                          showPopUp(false);
                                        }}
                                        class="block px-4 py-2 hover:bg-gray-100"
                                      >
                                        Make Inactive
                                      </a>
                                    )}
                                  </li>
                                )}
                                {serviceBag == 1 && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onViewGrid(data.oldIndex, 6);
                                        showPopUp(false);
                                      }}
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      Upload Invoices
                                    </a>
                                  </li>
                                )}
                                {deactivateBag == 1 && (
                                  <li>
                                    {data.Deactivate ? (
                                      <a
                                        onClick={() => {
                                          onBlockGrid(data.oldIndex, 8);
                                          showPopUp(false);
                                        }}
                                        class="block px-4 py-2 hover:bg-gray-100"
                                      >
                                        Activate Login
                                      </a>
                                    ) : (
                                      <a
                                        onClick={() => {
                                          onViewGrid(data.oldIndex, 7);
                                          showPopUp(false);
                                        }}
                                        class="block px-4 py-2 hover:bg-gray-100"
                                      >
                                        Deactivate Login
                                      </a>
                                    )}
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      ) : ////trial ended

                      //action added
                      keyData.key === "action3" ? (
                        <div>
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                              title="Click to Cancel Booking"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => {
                              onCancelEnquiry(data.oldIndex, 2);
                              showPopUp(false);

                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              x="0px"
                              y="0px"
                              width="24"
                              height="24"
                              viewBox="0 0 48 48"
                            >
                              <path
                                fill="#f44336"
                                d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
                              ></path>
                              <path
                                fill="#fff"
                                d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z"
                              ></path>
                              <path
                                fill="#fff"
                                d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z"
                              ></path>
                            </svg>
                          </button>

                          {/* <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => {
                              onHoldEnquiry(data.oldIndex, 2);
                              showPopUp(false);
                            }}
                          >
                            <svg
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M12 4C9.243 4 7 6.243 7 9h2c0-1.654 1.346-3 3-3s3 1.346 3 3c0 1.069-.454 1.465-1.481 2.255-.382.294-.813.626-1.226 1.038C10.981 13.604 10.995 14.897 11 15v2h2v-2.009c0-.024.023-.601.707-1.284.32-.32.682-.598 1.031-.867C15.798 12.024 17 11.1 17 9c0-2.757-2.243-5-5-5zm-1 14h2v2h-2z" />
                            </svg>
                          </button> */}
                        </div>
                      ) : keyData.key === "Map" ? (
                        <div>
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class={mainTable.submitButton}
                            title="Click to Map"
                            type="button"
                            onClick={() => {
                              onMap(data.oldIndex, 2);
                              showPopUp(false);
                            }}
                          >
                            Map
                          </button>
                        </div>
                      ) : keyData.key === "MapView" ? (
                        <div>
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class={mainTable.submitButton}
                            type="button"
                            title="Click to View"
                            onClick={() => {
                              onMapView(data.oldIndex, 2);
                              showPopUp(false);
                            }}
                          >
                            View
                          </button>
                        </div>
                      ) : keyData.key === "Invoices" ? (
                        <div className="relative inline-block ">
                          <span
                            onClick={() => {
                              onViewFile(data.oldIndex, 3, 1);
                              showPopUp(false);
                            }}
                            className={`truncate underline block ${
                              data?.ProformaInvoice ? "cursor-pointer" : ""
                            }`}
                          >
                            View
                          </span>
                        </div>
                      ) : keyData.key === "action5" ? (
                        <div>
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            title="Click to Check-in"
                            onClick={() => {
                              onConfirmBooking(data.oldIndex, 1);
                              showPopUp(false);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              height="28"
                              width="28"
                              viewBox="0 0 512 512"
                            >
                              <circle cx="352" cy="144" r="48" fill="#2196f3" />
                              <path
                                fill="#2196f3"
                                d="M352 224c-35 0-64 29-64 64v152c0 12 8 20 20 20s20-8 20-20v-56h48v56c0 12 8 20 20 20s20-8 20-20V288c0-35-29-64-64-64z"
                              />
                              <path
                                fill="#6a6ea9"
                                d="M144 64c-44 0-80 36-80 80v224c0 44 36 80 80 80h36c20 0 32-12 32-28s-12-28-32-28h-28c-10 0-16-6-16-16V144c0-10 6-16 16-16h28c20 0 32-12 32-28s-12-28-32-28h-36z"
                              />
                              <path
                                fill="#4caf50"
                                d="M336 272H208l24-24c6-6 6-16 0-22s-16-6-22 0l-60 60c-6 6-6 16 0 22l60 60c6 6 16 6 22 0s6-16 0-22l-24-24h128c9 0 16-7 16-16s-7-16-16-16z"
                              />
                            </svg>
                          </button>
                        </div>
                      ) : keyData.key === "action4" ? (
                        <div>
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            title="Click to Check-Out"
                            onClick={() => {
                              onLostEnquiry(data.oldIndex, 1);
                              
                              showPopUp(false);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              height="28"
                              width="28"
                              viewBox="0 0 512 512"
                            >
                              <circle cx="352" cy="144" r="48" fill="#2196f3" />
                              <path
                                fill="#2196f3"
                                d="M352 224c-35 0-64 29-64 64v152c0 12 8 20 20 20s20-8 20-20v-56h48v56c0 12 8 20 20 20s20-8 20-20V288c0-35-29-64-64-64z"
                              />
                              <path
                                fill="#6a6ea9"
                                d="M144 64c-44 0-80 36-80 80v224c0 44 36 80 80 80h36c20 0 32-12 32-28s-12-28-32-28h-28c-10 0-16-6-16-16V144c0-10 6-16 16-16h28c20 0 32-12 32-28s-12-28-32-28h-36z"
                              />
                              <path
                                fill="#f44336"
                                d="M208 272h128l-24-24c-6-6-6-16 0-22s16-6 22 0l60 60c6 6 6 16 0 22l-60 60c-6 6-16 6-22 0s-6-16 0-22l24-24H208c-9 0-16-7-16-16s7-16 16-16z"
                              />
                            </svg>
                          </button>
                        </div>
                      ) : keyData.key === "LaundryIssueView" ? (
                        <div>
                          <a
                            href="#"
                            className="text-[#3D6643] underline cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              onLaundryIssueView(data.oldIndex, 2);
                              showPopUp(false);
                            }}
                            title="click to view"
                            // className={mainTable.addButton}
                          >
                            View
                          </a>
                        </div>
                      ) : keyData.key === "action2" ? (
                        <div>
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => {
                              onConfirmBooking(data.oldIndex, 1);
                              showPopUp(false);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              height="23"
                              width="23"
                              viewBox="0 0 512 512"
                            >
                              <path
                                fill="#f44336"
                                d="M384 64v128h-32V96h-96V64h128zm0 384V320h-32v96h-96v32h128z"
                              />
                              <path
                                fill="#4caf50"
                                d="M48 272h264l-73.4 73.4 22.6 22.6L376 256 261.3 141.9l-22.7 22.6L312 240H48z"
                              />
                            </svg>
                          </button>

                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => {
                              onLostEnquiry(data.oldIndex, 1);
                              showPopUp(false);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                            >
                              <g
                                fill="none"
                                stroke="#ff4d4f"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              >
                                Map
                              </g>
                            </svg>
                          </button>
                        </div>
                      ) : keyData.key === "ProformaInvoice" ? (
                        <div className="relative inline-block max-w-[200px]">
                          <span
                            onClick={() => {
                              if (!data?.ProformaInvoice) {
                                // alert("Proforma Invoice is not available"); // You can replace with toast
                                return;
                              }
                              onViewFile(data.oldIndex, 3, 1);
                              showPopUp(false);
                            }}
                            className={`truncate underline block ${
                              data?.ProformaInvoice
                                ? "hover:text-green-800 text-green-500 cursor-pointer"
                                : "text-red-500 cursor-not-allowed"
                            }`}
                            title={
                              data?.ProformaInvoice
                                ? data.FileName
                                : "Proforma Invoice is not available"
                            }
                          >
                            View
                          </span>
                        </div>
                      ) : keyData.key === "TaxInvoice" ? (
                        <div className="relative inline-block max-w-[200px]">
                          <span
                            onClick={() => {
                              if (!data?.TaxInvoice) {
                                // alert("Proforma Invoice is not available"); // You can replace with toast
                                return;
                              }
                              onViewFile(data.oldIndex, 3, 2);
                              showPopUp(false);
                            }}
                            className={`truncate underline block ${
                              data?.TaxInvoice
                                ? "hover:text-green-800 text-green-500 cursor-pointer"
                                : "text-red-500 cursor-not-allowed"
                            }`}
                            title={
                              data?.TaxInvoice
                                ? data.FileName
                                : "Tax Invoice is not available"
                            }
                          >
                            View
                          </span>
                        </div>
                      ) : keyData.key === "PaymentInfoAction" ? (
                        <div className="flex justify-center">
                          <Link
                            to={"/paymentinfo"}
                            state={{
                              ...data,
                              isAdd: true,
                              isvisible3: false,
                              isData: tableData[rowIndex],
                              menuId: 13,
                            }}
                            // onClick={() => onServiceProvideGrid(rowIndex)}
                            className={mainTable.addButton}
                            title="click to Add"
                            class="block px-4 py-2 hover:bg-gray-100"
                          >
                            Add
                          </Link>
                        </div>
                      ) : keyData.key === "ConsumptionView" ? (
                        <div>
                          <a
                            href="#"
                            className="text-[#3D6643] underline cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              onConsumptionView(data.oldIndex, 2);
                              showPopUp(false);
                            }}
                            title="click to view"
                          >
                            View
                          </a>
                        </div>
                      ) : keyData.key === "action2" ? (
                        <div>
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => {
                              onConfirmBooking(data.oldIndex, 1);
                              showPopUp(false);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              height="23"
                              width="23"
                              viewBox="0 0 512 512"
                            >
                              <path
                                fill="#f44336"
                                d="M384 64v128h-32V96h-96V64h128zm0 384V320h-32v96h-96v32h128z"
                              />
                              <path
                                fill="#4caf50"
                                d="M48 272h264l-73.4 73.4 22.6 22.6L376 256 261.3 141.9l-22.7 22.6L312 240H48z"
                              />
                            </svg>
                          </button>

                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => {
                              onLostEnquiry(data.oldIndex, 1);
                              showPopUp(false);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                            >
                              <g
                                fill="none"
                                stroke="#ff4d4f"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              >
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                <polyline
                                  points="16 17 21 12 16 7"
                                  stroke="#52c41a"
                                />
                                <line
                                  x1="21"
                                  y1="12"
                                  x2="9"
                                  y2="12"
                                  stroke="#52c41a"
                                />
                              </g>
                            </svg>
                          </button>
                          {/* <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => {
                              onHoldEnquiry(data.oldIndex, 1);
                              showPopUp(false);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="21"
                              height="21"
                              viewBox="0 0 24 24"
                            >
                              <circle cx="12" cy="12" r="10" fill="#ff4d4f" />
                              <line
                                x1="15"
                                y1="9"
                                x2="9"
                                y2="15"
                                stroke="#ffffff"
                                stroke-width="2"
                                stroke-linecap="round"
                              />
                              <line
                                x1="9"
                                y1="9"
                                x2="15"
                                y2="15"
                                stroke="#ffffff"
                                stroke-width="2"
                                stroke-linecap="round"
                              />
                            </svg>
                          </button> */}
                        </div>
                      ) : keyData.key === "actionWithOutInactive" ? (
                        <div>
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => showPopUp(!viewsAll, rowIndex)}
                          >
                            <svg
                              class="w-6 h-6"
                              aria-hidden="true"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                            </svg>
                          </button>
                          {viewsAll && currentRowIndex == rowIndex && (
                            <div
                              ref={dropdownRef}
                              id="dropdownDots"
                              class="z-10 bg-white absolute right-14 divide-y divide-gray-100 rounded-lg shadow w-44"
                            >
                              <ul
                                class=""
                                aria-labelledby="dropdownMenuIconButton"
                              >
                                {viewBag == 1 && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onViewGrid(data.oldIndex, 1);
                                        showPopUp(false);
                                      }}
                                      title="click to view"
                                      class="block px-4 py-2 text-left hover:bg-gray-100"
                                    >
                                      View
                                    </a>
                                  </li>
                                )}
                                {editBag == 1 && !data.InActivatedBy && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onEditGrid(
                                          data.oldIndex,
                                          2
                                        );
                                        showPopUp(false);
                                      }}
                                      class="block px-4 py-2 text-left hover:bg-gray-100"
                                    >
                                      Edit
                                    </a>
                                  </li>
                                )}
                                {deleteBag == 1 && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onDeleteGrid(
                                          data.oldIndex,
                                          3
                                        );
                                        showPopUp(false);
                                      }}
                                      class="block px-4 py-2 text-left hover:bg-gray-100"
                                    >
                                      Delete
                                    </a>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      ) : keyData.key === "actionWithOutInactiveAndDelete" ? (
                        <div>
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => showPopUp(!viewsAll, rowIndex)}
                          >
                            <svg
                              class="w-6 h-6"
                              aria-hidden="true"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                            </svg>
                          </button>
                          {viewsAll && currentRowIndex == rowIndex && (
                            <div
                              ref={dropdownRef}
                              id="dropdownDots"
                              class="z-10 bg-white absolute right-14 divide-y divide-gray-100 rounded-lg shadow w-44"
                            >
                              <ul
                                class=""
                                aria-labelledby="dropdownMenuIconButton"
                              >
                                {viewBag == 1 && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onViewGrid(data.oldIndex, 1);
                                        showPopUp(false);
                                      }}
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      View
                                    </a>
                                  </li>
                                )}
                                {editBag == 1 && !data.InActivatedBy && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onEditGrid(
                                          data.oldIndex,

                                          2
                                        );
                                        showPopUp(false);
                                      }}
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      Edit
                                    </a>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                            ) : keyData.key === "actionWithOutInactive1" ? (
                              <div>
                                <button
                                  id="dropdownMenuIconButton"
                                  data-dropdown-toggle="dropdownDots"
                                  class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                                  type="button"
                                  onClick={() => showPopUp(!viewsAll, rowIndex)}
                                >
                                  <svg
                                    class="w-6 h-6"
                                    aria-hidden="true"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                                  </svg>
                                </button>
                                {viewsAll && currentRowIndex == rowIndex && (
                                  <div
                                    ref={dropdownRef}
                                    id="dropdownDots"
                                    class="z-10 bg-white absolute right-14 divide-y divide-gray-100 rounded-lg shadow w-44"
                                  >
                                    <ul
                                      class=""
                                      aria-labelledby="dropdownMenuIconButton"
                                    >
                                      {viewBag == 1 && (
                                        <li>
                                          <a
                                            onClick={() => {
                                              onViewGrid(data.oldIndex, 1);
                                              showPopUp(false);
                                            }}
                                            title="click to view"
                                            class="block px-4 py-2 hover:bg-gray-100"
                                          >
                                            View
                                          </a>
                                        </li>
                                      )}
                                      {editBag == 1 && !data.InActivatedBy && (
                                        <li>
                                          <a
                                            onClick={() => {
                                              onEditGrid(
                                                data.oldIndex,
                                                2
                                              );
                                              showPopUp(false);
                                            }}
                                            class="block px-4 py-2 hover:bg-gray-100"
                                          >
                                            Edit
                                          </a>
                                        </li>
                                      )}
                                      {/* {deleteBag == 1 && (
                                        <li>
                                          <a
                                            onClick={() => {
                                              onDeleteGrid(
                                                data.oldIndex,
                                                3
                                              );
                                              showPopUp(false);
                                            }}
                                            class="block px-4 py-2 hover:bg-gray-100"
                                          >
                                            Delete
                                          </a>
                                        </li>
                                      )} */}
                                    </ul>
                                  </div>
                                )}
                              </div>
                            ) : keyData.key === "actionWithOutInactiveAndDelete1" ? (
                              <div>
                                <button
                                  id="dropdownMenuIconButton"
                                  data-dropdown-toggle="dropdownDots"
                                  class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                                  type="button"
                                  onClick={() => showPopUp(!viewsAll, rowIndex)}
                                >
                                  <svg
                                    class="w-6 h-6"
                                    aria-hidden="true"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                                  </svg>
                                </button>
                                {viewsAll && currentRowIndex == rowIndex && (
                                  <div
                                    ref={dropdownRef}
                                    id="dropdownDots"
                                    class="z-10 bg-white absolute right-14 divide-y divide-gray-100 rounded-lg shadow w-44"
                                  >
                                    <ul
                                      class=""
                                      aria-labelledby="dropdownMenuIconButton"
                                    >
                                      {viewBag == 1 && (
                                        <li>
                                          <a
                                            onClick={() => {
                                              onViewGrid(data.oldIndex, 1);
                                              showPopUp(false);
                                            }}
                                            class="block px-4 py-2 hover:bg-gray-100"
                                          >
                                            View
                                          </a>
                                        </li>
                                      )}
                                      {editBag == 1 && !data.InActivatedBy && (
                                        <li>
                                          <a
                                            onClick={() => {
                                              onEditGrid(
                                                data.oldIndex,
      
                                                2
                                              );
                                              showPopUp(false);
                                            }}
                                            class="block px-4 py-2 hover:bg-gray-100"
                                          >
                                            Edit
                                          </a>
                                        </li>
                                      )}
                                    </ul>
                                  </div>
                                )}
                              </div>
                      ) : keyData.key === "Report" ? (
                        <div className="flex">
                          <div className="flex flex-col gap-y-2">
                            <button
                              id="dropdownMenuIconButton"
                              data-dropdown-toggle="dropdownDots"
                              className="inline-flex items-center gap-1 text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                              type="button"
                              onClick={() => onSchoolView(rowIndex)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                              >
                                <path d="M14 2H6a2 2 0 0 0-2 2v16c0 1.103.897 2 2 2h12a2 2 0 0 0 2-2V8l-6-6zM13 3.5L18.5 9H13V3.5zM8 15v-4h1.5a1.5 1.5 0 1 1 0 3H9v1H8zm4-2h1.5v-1H12v-1h2v4h-2v-1zm4.5 1.5v-3h-1v-1H18v4h-1.5z" />
                              </svg>
                              View
                            </button>
                          </div>
                        </div>
                      ) : keyData.title === "S.No." ? (
                        <div>
                          {startIndex +
                            rowIndex +
                            1 +
                            (currentPage - 1) * itemsPerPage}
                        </div>
                      ) : keyData.title === "S.No." && data.InActivatedBy ? (
                        <div class={keyData.width1}>
                          {startIndex +
                            rowIndex +
                            1 +
                            (currentPage - 1) * itemsPerPage}
                        </div>
                      ) : keyData.title === "S.No." && data.Deactivate ? (
                        <div class={keyData.width1}>
                          {startIndex +
                            rowIndex +
                            1 +
                            (currentPage - 1) * itemsPerPage}
                        </div>
                      ) : keyData.key === "userImage" ||
                        keyData.key === "RoomTypeImage" ||
                        keyData.key === "Photo" ||
                        keyData.key === "FoodImage" ||
                        keyData.key === "UserProfileImg" ? ( // Will be used in functionality
                        <img
                          class={``}
                          onClick={() => {
                            setViewImage(() => {
                              return { popup: true, url: data[keyData.key] };
                            });
                          }}
                          type="image"
                          src={data[keyData.key] ? data[keyData.key] : download}
                          alt="Image"
                          className="rounded-none w-12 h-12"
                          width={keyData.width}
                        />
                      ) : data[keyData.key1] === 1 ? (
                        <img
                          onClick={() => {
                            setViewImage(() => {
                              return { popup: true, url: data[keyData.key] };
                            });
                          }}
                          type="image"
                          src={data[keyData.key]}
                          alt="Image"
                          className="rounded-full w-12 h-12"
                          width={keyData.width}
                        />
                      ) : data[keyData.key1] === 2 &&
                        data[keyData.key]?.startsWith(
                         "https://www.youtube.com/embed/"
                        ) ? (
                        <img
                          onClick={() => {
                            setViewImage(() => {
                              return { popup: true, url: data[keyData.key] };
                            });
                          }}
                          type="image"
                          src={youtube}
                          alt="Image"
                          className="rounded-full w-12 h-12"
                          width={keyData.width}
                        />
                      ) : data[keyData.key1] === 3 &&
                        data[keyData.key]?.endsWith(".pdf") ? (
                        <img
                          onClick={() => {
                            setViewImage(() => {
                              return { popup: true, url: data[keyData.key] };
                            });
                          }}
                          type="image"
                          src={pdf}
                          alt="Image"
                          className="rounded-full w-12 h-12"
                          width={keyData.width}
                        />
                      ) : data.InActivatedBy ? (
                        <div className={keyData.width1}>
                          <div
                            class="truncate relative text-red-600"
                            title={data[keyData.key]}
                          >
                            {data[keyData.key]}
                          </div>
                          <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none"></div>
                        </div>
                      ) : data.Deactivate ? (
                        <div className={keyData.width1}>
                          <div
                            class="truncate relative text-red-600 opacity-70 cursor-not-allowed"
                            title={data[keyData.key]}
                         >
                            {data[keyData.key]}
                          </div>
                          <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none"></div>
                        </div>
                      ) : (
                        <div class="relative">
                          <div
                            class="truncate relative"
                            title={data[keyData.key]}
                          >
                            {data[keyData.key]}
                          </div>
                          <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none"></div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ))
            ) : (
              <div class="text-center text-red-500 mt-4">No record found</div>
            )}
          </div>
        </div>
      </div>

      <div className={mainTable.tableMobile} role="table">
        <div
          className={`w-full ${
            tableView ? "" : "overflow-y-auto"
          } lg:h-96 h-full`}
        >
          {currentData.length > 0 &&
            currentData.map((data, rowIndex) => (
              <div scope="col" class={mainTable.mobileTable}>
                {headerData.map((keyData) => (
                  <div scope="cell" class={mainTable.tableData} role="cell">
                    {keyData.key === "address" ? (
                      <div className="flex border p-1">
                        <div className="flex basis-1/2 font-bold">
                          {keyData.title}
                        </div>
                        <div className="flex basis-1/2">
                          <button
                            onClick={() => onAddressGrid(data.oldIndex, 1)}
                            class="relative px-5 py-2 overflow-hidden font-medium text-gray-600 bg-gray-100 border border-gray-100 rounded-lg shadow-inner group"
                          >
                            <span class="absolute top-0 left-0 w-0 h-0 transition-all duration-200 border-t-2 border-gray-600 group-hover:w-full ease"></span>
                            <span class="absolute bottom-0 right-0 w-0 h-0 transition-all duration-200 border-b-2 border-gray-600 group-hover:w-full ease"></span>
                            <span class="absolute top-0 left-0 w-full h-0 transition-all duration-300 delay-200 bg-gray-600 group-hover:h-full ease"></span>
                            <span class="absolute bottom-0 left-0 w-full h-0 transition-all duration-300 delay-200 bg-gray-600 group-hover:h-full ease"></span>
                            <span class="absolute inset-0 w-full h-full duration-300 delay-300 bg-gray-900 opacity-0 group-hover:opacity-100"></span>
                            <span class="relative transition-colors duration-300 delay-200 group-hover:text-white ease">
                              View
                            </span>
                          </button>
                        </div>
                      </div>
                    ) : keyData.key === "actionWithOutInactive" ? (
                      <div class={mainTable.tableData}>
                        <div className="md:block hidden">
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => showPopUp(!viewsAll, rowIndex)}
                          >
                            <svg
                              class="w-6 h-6"
                              aria-hidden="true"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                            </svg>
                          </button>
                        </div>
                        <div className="flex gap-1 justify-center">
                          {viewBag === 1 && (
                            <button
                              className="bg-[#3D6643] w-full text-white p-1 rounded-lg"
                              onClick={() => onViewGrid(data.oldIndex, 1)}
                            >
                              View
                            </button>
                         )}
                          {editBag === 1 && (
                            <button
                              className="bg-[#3D6643] w-full text-white p-1 rounded-lg"
                              onClick={() => {
                                onEditGrid(data.oldIndex, 2);
                                showPopUp(false);
                              }}
                            >
                              Edit
                            </button>
                          )}
                          {deleteBag === 1 && (
                            <button
                              className="bg-[#3D6643] w-full text-white p-1 rounded-lg"
                              onClick={() => onDeleteGrid(data.oldIndex, 3)}
                            >
                              Delete
                            </button>
                          )}
                        </div>
                      </div>
                    ) : keyData.key === "action" ? (
                      <div class={mainTable.tableData}>
                        <div className="md:block hidden">
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => showPopUp(!viewsAll, rowIndex)}
                          >
                            <svg
                              class="w-6 h-6"
                              aria-hidden="true"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                            </svg>
                          </button>
                        </div>
                        <div className="flex gap-1 justify-center">
                          {viewBag === 1 && (
                            <button
                              className="bg-[#3D6643] w-full text-white p-1 rounded-lg"
                              onClick={() => onViewGrid(data.oldIndex, 1)}
                            >
                              View
                            </button>
                          )}
                          {editBag === 1 && (
                            <button
                              className="bg-[#3D6643] w-full text-white p-1 rounded-lg"
                              onClick={() => {
                                onEditGrid(data.oldIndex, 2);
                                showPopUp(false);
                              }}
                            >
                              Edit
                            </button>
                          )}
                          {deleteBag === 1 && (
                            <button
                              className="bg-[#3D6643] w-full text-white p-1 rounded-lg"
                              onClick={() => onDeleteGrid(data.oldIndex, 3)}
                            >
                              Delete
                            </button>
                          )}
                          {blockBag === 1 && (
                            <div className="w-full">
                              {data.InActivatedBy ? (
                                <button
                                  onClick={() => {
                                    onBlockGrid(data.oldIndex, 5);
                                    showPopUp(false);
                                  }}
                                  className="bg-[#3D6643] w-full text-white p-2 rounded-lg"
                                >
                                  Active
                                </button>
                              ) : (
                                <button
                                  onClick={() => {
                                    onBlockGrid(data.oldIndex, 4);
                                    showPopUp(false);
                                  }}
                                  className="bg-[#3D6643] w-full text-white p-2 rounded-lg"
                                >
                                  Inactive
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    )  : keyData.key === "actionWithOutInactiveAndDelete" ? (
                      <div class={mainTable.tableData}>
                        <div className="md:block hidden">
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => showPopUp(!viewsAll, rowIndex)}
                          >
                            <svg
                              class="w-6 h-6"
                              aria-hidden="true"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                            </svg>
                          </button>
                        </div>
                        <div className="flex gap-1 justify-center">
                          {viewBag === 1 && (
                            <button
                              className="bg-[#3D6643] w-full text-white p-1 rounded-lg"
                              onClick={() => onViewGrid(data.oldIndex, 1)}
                            >
                              View
                            </button>
                          )}
                          {editBag === 1 && (
                            <button
                              className="bg-[#3D6643] w-full text-white p-1 rounded-lg"
                              onClick={() => {
                                onEditGrid(data.oldIndex, 2);
                                showPopUp(false);
                              }}
                            >
                              Edit
                            </button>
                          )}
                        </div>
                      </div>
                    ): keyData.key == "LaundryIssueView" ? (
                       <div className="flex border p-1">
                        <div className="flex basis-1/2 font-bold ">
                            {keyData.title}
                          </div>
                        <div className="flex basis-1/2">
                          <a
                            href="#"
                           className="text-[#3D6643] underline cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              onLaundryIssueView(data.oldIndex, 2);
                              showPopUp(false);
                            }}
                            title="click to view"
                          >
                            View
                          </a>
                        </div>
                        </div>
                      ): keyData.key == "ConsumptionView" ? (
                       <div className="flex border p-1">
                        <div className="flex basis-1/2 font-bold ">
                            {keyData.title}
                          </div>
                        <div className="flex basis-1/2">
                          <a
                            href="#"
                           className="text-[#3D6643] underline cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              onLaundryIssueView(data.oldIndex, 2);
                              showPopUp(false);
                            }}
                            title="click to view"
                          >
                            View
                          </a>
                        </div>
                        </div>
                      ): keyData.key === "action5" ? (
                   
                      
                        <div className="flex basis-1/2">
                          <button
                             onClick={() => {
                              onConfirmBooking(data.oldIndex, 1);
                              showPopUp(false);
                            }}
                             className="bg-[#3D6643] w-full text-white p-2 rounded-lg"
                          >
                          <span>
                              Check In
                            </span>
                          </button>
                        </div>
                      ) : keyData.key === "action4" ? (
                        
                         <div className="flex basis-1/2">
                          <button
                             onClick={() => {
                             onLostEnquiry(data.oldIndex, 1);
                              showPopUp(false);
                            }}
                             className="bg-[#3D6643] w-full text-white p-2 rounded-lg"
                          >
                          <span>
                              Check Out
                            </span>
                          </button>
                        </div>
                      )  : keyData.key === "userImage" ||
                       keyData.key === "Photo" ||
                        keyData.key === "FoodImage" ||
                      keyData.key === "RoomTypeImage" ||
                      keyData.key === "UserProfileImg" ? (
                      <div className="flex justify-center ">
                        <input
                          type="image"
                          src={data[keyData.key]}
                          alt="Image"
                          className="rounded-full  w-20 md:w-12 md:h-12"
                        />
                      </div>
                    ) : data[keyData.key1] === 1 ? (
                      <div className="flex justify-center ">
                        <img
                          onClick={() => {
                            setViewImage(() => {
                              return { popup: true, url: data[keyData.key] };
                            });
                          }}
                          type="image"
                          src={data[keyData.key]}
                          alt="Image"
                          className="rounded-full w-12 h-12  "
                          width={keyData.width}
                        />
                      </div>
                    ) : data[keyData.key1] === 2 &&
                      data[keyData.key]?.startsWith(
                        "https://www.youtube.com/embed/"
                      ) ? (
                      <div className="flex justify-center ">
                        <img
                          onClick={() => {
                            setViewImage(() => {
                              return { popup: true, url: data[keyData.key] };
                            });
                          }}
                          type="image"
                          src={youtube}
                          alt="Image"
                          className="rounded-full w-12 h-12"
                          width={keyData.width}
                        />
                      </div>
                    ) : data[keyData.key1] === 3 &&
                      data[keyData.key]?.endsWith(".pdf") ? (
                      <div className="flex justify-center ">
                        <img
                          onClick={() => {
                            setViewImage(() => {
                              return { popup: true, url: data[keyData.key] };
                            });
                          }}
                          type="image"
                          src={pdf}
                          alt="Image"
                          className="rounded-full w-12 h-12"
                          width={keyData.width}
                        />
                      </div>
                    ) : keyData.title === "S.No." ? (
                      <div className="flex border p-1">
                        <div className="flex basis-1/2 font-bold">
                          {keyData.title}
                        </div>
                        <div>
                          {startIndex +
                            rowIndex +
                            1 +
                            (currentPage - 1) * itemsPerPage}
                        </div>
                      </div>
                    ) : keyData.key === "Phone" && data.ClientPhoneNo == "" ? (
                      <div className="flex basis-1/2">{"-"}</div>
                    ) : data.InActivatedBy ? (
                      <div className={keyData.width1}>
                        <div className="flex border p-1 ">
                          <div className="flex basis-1/2 font-bold ">
                            {keyData.title}
                          </div>
                          <div className="flex basis-1/2 truncate relative text-red-600">
                            {data[keyData.key]}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="flex border p-1">
                        <div className="flex basis-1/2 font-bold">
                          {keyData.title}
                        </div>
                        <div className="flex basis-1/2">
                          {data[keyData.key]}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ))}
        </div>
      </div>
      <MainPopup
        popUpOpen={viewImage.popup}
        setpopUpOpen={() => setViewImage({ popup: false, url: "" })}
      >
        <div>
          <button class="w-full">
            <span
              className="text-white flex justify-end"
              onClick={() => setViewImage({ popup: false, url: "" })}
              class="text-2xl p-0 m-o block float-right mr-3"
            >
              &times;
            </span>
          </button>
          <div className="flex justify-center p-12 items-center">
            {viewImage?.url ? (
              viewImage.url.startsWith("https://www.youtube.com/embed/") ? (
                <iframe
                  title="Video"
                  src={viewImage.url}
                  allowFullScreen
                  className="h-96 w-96"
                ></iframe>
              ) : viewImage.url.endsWith(".pdf") ? (
                <a
                  href={viewImage.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={pdf} // You can replace this with a custom PDF icon
                    alt="PDF"
                    className="w-20 h-20"
                  />
                  <p>View PDF</p>
                </a>
              ) : (
                <img src={viewImage.url} className="h-96 w-96" />
              )
            ) : (
              <p>No image or video available</p>
            )}
          </div>
        </div>
      </MainPopup>
    </div>
  );
};

export default TableGrid;
